import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { AuthService } from '@gyselroth/angular-auth';
import { OrganizationService } from './shared/organization/services/organization.service';
import { OrganizationConfigService } from './shared/organization/services/organizationConfig.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private organizationService: OrganizationService,
    private organizationConfigService: OrganizationConfigService,
    private router: Router
  ) {
    this.organizationConfigService.initiateOrganizationFromConfig();

    this.hideLoaderAfterInitialNavigation();

    this.organizationService.getOrganizationFromGQL();
  }

  private hideLoaderAfterInitialNavigation(): void {
    const navigationEnd$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    );

    combineLatest([this.authService.loggedIn$.pipe(take(1)), navigationEnd$])
      .pipe(
        filter(([loggedIn, event]) => {
          if (!loggedIn) {
            return true;
          }

          return !this.isTemporaryAuthRoute(event.urlAfterRedirects);
        }),
        take(1)
      )
      .subscribe(() => {
        this.hideLoader();
      });
  }

  private isTemporaryAuthRoute(url: string): boolean {
    return (
      url.startsWith('/login') ||
      url.startsWith('/msal-callback') ||
      url.startsWith('/msal-silent-redirect')
    );
  }

  private hideLoader(): void {
    const loaderFadeOutTimeout = 300;
    const body = this.document.body;
    const loader = this.document.getElementById('login-loader');

    if (!loader) {
      return;
    }

    loader.style.setProperty(
      '--login-loader-fade-out-timeout',
      `${loaderFadeOutTimeout}ms`
    );

    loader.classList.add('ready-for-take-off');
    body.classList.remove('no-scroll');

    setTimeout(() => {
      loader.remove();
    }, loaderFadeOutTimeout + 10);
  }
}
